import { PostRequest } from "./http/BaseRequest";
import { ServerResponse } from "./http/settings";
import { clearCache } from "@utils/localCache";
import { locationsCacheKey } from "@components/Pages/Locations/useLocationsControl";
import W2UiFilterBuilder from "./w2ui";
import { SearchItem } from "./w2ui/w2const";
import { castResponse } from "@utils/hooks/useTypedRequest";
import { RecordResponse } from "./http/responses/BaseResponse";

export interface ILocation {
  Id: string;
  Name: string;
  //LocId: string;
  Code: string;
  Address: string;
  Coord: string; //unused in table?
  Notes?: string; //unused in table?
  Uuid: string;
}

export interface IAddLocationParams extends ILocation { }

export interface IEditLocation extends IAddLocationParams {
  edit: boolean;
}

export interface ILocationForList extends ILocation {
  Created: number; //unused in table?
  Updated: number; //unused in table?
}

export interface IAddNewLocationResponse extends ServerResponse {
  Record?: number;
}

export class GetLocationsRequest extends PostRequest {
  constructor(offset: number = 0, limit: number = 20, search?: string) {
    const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset)
    if (search && typeof search === "string") {
      builder.setSearch([SearchItem.textContains("search", search)]);
    }
    const params = builder.build().stringParams;
    super("/location/list", params);
  }
}
export class AddLocationRequest extends PostRequest {
  constructor(params: IAddLocationParams) {
    clearCache(locationsCacheKey);
    const p = {
      name: params.Name.trim(),
      locId: params.Code.trim(),
      address: params.Address?.trim() || undefined,
      coords: params.Coord?.trim() || undefined,
      notes: params.Notes?.trim() || undefined,
    };
    super("/admin/location/add", p);
  }
}

export class EditLocationRequest extends PostRequest {
  constructor(params: IEditLocation) {
    clearCache(locationsCacheKey);
    const p = {
      id: params.Id,
      name: params.Name.trim(),
      locId: params.Code.trim(),
      address: params.Address?.trim() || undefined,
      coords: params.Coord?.trim() || undefined,
      notes: params.Notes?.trim() || undefined,
      edit: true,
    };
    super("/admin/location/add", p);
  }
}

export interface LocationMeta {
  ElectricScheme: unknown;
}

// export const EditLocationMeta = {
//   makeRequest(id: string, meta?: string | LocationMeta) {
//     let params = { id, meta, edit: true };
//     if (meta !== undefined && typeof meta !== "string") {
//       params = {
//         ...params,
//         meta: JSON.stringify(params.meta),
//       }
//     }
//     return new PostRequest(`/admin/location/add`, { ...params });
//   },
//   makeResponse: castResponse<RecordResponse<string>>,
// }

// interface LocationResponse {
//   id: number;
//   meta: LocationMeta;
// }

// export const GetLocation = {
//   makeRequest(locationID: number) {
//     return new PostRequest("/admin/location/get", { id: locationID });
//   },
//   makeResponse: castResponse<RecordResponse<LocationResponse>>,
// }

// export class DeleteLocationRequest extends PostRequest {
//   constructor(id: string) {
//     clearCache(locationsCacheKey);
//     super("/admin/location/delete", { id });
//   }
// }
